import React, { createContext, useState, useContext, useEffect, ReactNode } from 'react';

interface AuthContextType {
  isAuthenticated: boolean;
  isLoading: boolean; // <-- NOVO ESTADO
  user: { username: string } | null;
  login: (username: string, password: string) => Promise<boolean>;
  logout: () => void;
}

const defaultAuthContext: AuthContextType = {
  isAuthenticated: false,
  isLoading: true, // <-- Inicia como true
  user: null,
  login: async () => false,
  logout: () => {}
};

const AuthContext = createContext<AuthContextType>(defaultAuthContext);

export const useAuth = () => useContext(AuthContext);

interface AuthProviderProps {
  children: ReactNode;
}

const ADMIN_USERNAME = 'pacheco';
const ADMIN_PASSWORD = 'dewas2212@';

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [user, setUser] = useState<{ username: string } | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true); // <-- NOVO ESTADO

  useEffect(() => {
    try {
      const storedAuth = localStorage.getItem('admin_auth');
      if (storedAuth) {
        const parsedAuth = JSON.parse(storedAuth);
        setIsAuthenticated(true);
        setUser({ username: parsedAuth.username });
      }
    } catch (error) {
      console.error('Erro ao analisar dados de autenticação:', error);
      localStorage.removeItem('admin_auth');
    } finally {
      // <-- IMPORTANTE: Independentemente do resultado, a verificação terminou.
      setIsLoading(false);
    }
  }, []);

  const login = async (username: string, password: string): Promise<boolean> => {
    if (username === ADMIN_USERNAME && password === ADMIN_PASSWORD) {
      setIsAuthenticated(true);
      setUser({ username });
      localStorage.setItem('admin_auth', JSON.stringify({ username }));
      return true;
    }
    return false;
  };

  const logout = () => {
    setIsAuthenticated(false);
    setUser(null);
    localStorage.removeItem('admin_auth');
  };

  const contextValue: AuthContextType = {
    isAuthenticated,
    isLoading, // <-- Expondo o novo estado
    user,
    login,
    logout
  };

  return (
    <AuthContext.Provider value={contextValue}>
      {children}
    </AuthContext.Provider>
  );
};